// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VKhm","newExpiryDate":"styles_newExpiryDate__1TDak","footer":"styles_footer__3PWeG"};